import { useEffect } from 'react'
import { atom, selector, useRecoilState, useRecoilValue } from 'recoil'
import { getRequest } from '/src/httpClient'

export const getAuthenticatedUser = async () => {
  return await getRequest('/api/user/is-authenticated', new AbortController())
}

/*export const authenticatedUserSelector = selector({
  key: 'authenticatedUserSelector',
  get: async ({ get }) => getAuthenticatedUser()
})*/

export const authenticatedUserState = atom({
  key: 'authenticatedUserState',
  default: false
})

export const useAuthenticatedUser = () => {
  return useRecoilValue(authenticatedUserState)
}
